import React from "react";
import { LayoutDashboard, Store, CreditCard, ScrollText, ShieldCheck, Layers, Palette, Settings, UserRound, Mail } from "lucide-react";
import AppShell from "@/components/app/AppShell";

const groups = [
  { label: "Overview", items: [
    { to: "/admin", end: true, icon: LayoutDashboard, label: "Platform Overview", tid: "admin-sidebar-overview" },
  ] },
  { label: "Management", items: [
    { to: "/admin/vendors", icon: Store, label: "Vendors & Stores", tid: "admin-sidebar-vendors" },
    { to: "/admin/plans", icon: Layers, label: "Plans", tid: "admin-sidebar-plans" },
    { to: "/admin/subscriptions", icon: CreditCard, label: "Subscriptions", tid: "admin-sidebar-subscriptions" },
    { to: "/admin/themes", icon: Palette, label: "Themes", tid: "admin-sidebar-themes" },
  ] },
  { label: "System", items: [
    { to: "/admin/settings", icon: Settings, label: "Setup", tid: "admin-sidebar-settings" },
    { to: "/admin/email-templates", icon: Mail, label: "Email Templates", tid: "admin-sidebar-email-templates" },
    { to: "/admin/profile", icon: UserRound, label: "My Profile", tid: "admin-sidebar-profile" },
    { to: "/admin/audit", icon: ScrollText, label: "Audit Logs", tid: "admin-sidebar-audit" },
  ] },
];

export default function AdminLayout() {
  return (
    <AppShell
      groups={groups} homePath="/admin" rootLabel="Platform Overview" roleLabel="Super Admin" menuLinks={[{ to: "/admin/profile", icon: UserRound, label: "My Profile" }, { to: "/admin/settings", icon: Settings, label: "Setup" }]}
      logoutTestId="admin-logout" userMenuTestId="admin-user-menu" searchTestId="admin-menu-search" toggleTestId="admin-sidebar-toggle"
      sidebarFooter={
        <div className="rounded-lg bg-gradient-to-br from-blue-50 to-orange-50 border border-blue-100 px-3 py-2.5 flex items-center gap-2">
          <span className="w-7 h-7 rounded-lg bg-orange-100 text-orange-600 flex items-center justify-center"><ShieldCheck size={15} /></span>
          <div className="leading-tight"><div className="text-[12px] font-bold text-neutral-900">Super Admin</div><div className="text-[11px] text-slate-500">Full platform access</div></div>
        </div>
      }
      topRight={<span className="hidden md:inline-flex items-center gap-1.5 h-7 px-2.5 rounded-md bg-orange-50 border border-orange-200 text-[11px] font-semibold text-orange-700"><ShieldCheck size={12} /> Platform Administration</span>}
    />
  );
}
